import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";


const getReconciliations = function(state:RootState) {
    return state.reconciliation;
  };

  export const getReconciliationsDetail = createSelector(getReconciliations,(reconciliation)=>{
    return reconciliation
  })
